module.exports = __webpack_public_path__ + "img/app-yjmh.01324cbe.webp";